import { render, staticRenderFns } from "./ForeplayIcon.vue?vue&type=template&id=52e94774&scoped=true"
import script from "./ForeplayIcon.vue?vue&type=script&lang=js"
export * from "./ForeplayIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e94774",
  null
  
)

export default component.exports